export const categories = [
  { id: 'romance', name: '恋爱', icon: 'ri-heart-line', description: '浪漫甜蜜的韩国恋爱漫画，温馨动人的爱情故事', count: 128 },
  { id: 'fantasy', name: '奇幻', icon: 'ri-magic-line', description: '充满想象力的奇幻世界，精彩纷呈的冒险之旅', count: 95 },
  { id: 'action', name: '动作', icon: 'ri-sword-line', description: '热血沸腾的动作韩漫，紧张刺激的打斗场面', count: 87 },
  { id: 'thriller', name: '悬疑', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑故事，扑朔迷离的剧情发展', count: 64 },
  { id: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松愉快的搞笑韩漫，让你开怀大笑', count: 73 },
  { id: 'drama', name: '剧情', icon: 'ri-film-line', description: '引人入胜的剧情韩漫，深刻动人的故事叙述', count: 82 },
  { id: 'horror', name: '恐怖', icon: 'ri-ghost-line', description: '惊悚恐怖的韩漫作品，挑战你的胆量极限', count: 41 },
  { id: 'school', name: '校园', icon: 'ri-building-line', description: '青春校园题材韩漫，记录美好的学生时代', count: 56 },
];